import { ref } from 'vue'

interface ToastOptions {
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
  duration?: number
}

const visible = ref(false)
const message = ref('')
const type = ref<'success' | 'error' | 'warning' | 'info'>('info')

export function useToast() {
  const show = (options: ToastOptions) => {
    message.value = options.message
    type.value = options.type
    visible.value = true

    setTimeout(() => {
      visible.value = false
    }, options.duration || 3000)
  }

  const success = (msg: string) => show({ message: msg, type: 'success' })
  const error = (msg: string) => show({ message: msg, type: 'error' })
  const warning = (msg: string) => show({ message: msg, type: 'warning' })
  const info = (msg: string) => show({ message: msg, type: 'info' })

  return {
    visible,
    message,
    type,
    show,
    success,
    error,
    warning,
    info
  }
} 